import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import SwalComponent from '../../utils/custom-swal.component';
import * as moment from 'moment';
import { FormService } from './../../api/form.service';
import { UserProfileService } from './../../api/user-profile.service';
import { TransactionService } from '../../api/transaction.service';
@Component({
  selector: 'iv-payment-due-date',
  templateUrl: './payment-duedate.component.html',
  styleUrls: ['./payment-duedate.component.scss']
})
export class PaymentDuedateComponent implements OnInit, OnChanges {
  @Input() transaction;
  @Input() warningText: string = '';
  @Input() disabled = false;
  @Input() isRequired = false;
  @Input() isSummaryOrReview = false;
  @Output() paymentDuedateChanged;
  @ViewChild('warnDateValidAlert', { static: true }) warnDateValidAlert: SwalComponent;
  paymentdueDateForm;
  swalOptions: any = {};

  constructor(private fb: UntypedFormBuilder,
    private formService: FormService,
    private userProfileService: UserProfileService,
    private transactionService: TransactionService
  ) {
    this.paymentDuedateChanged = new EventEmitter();
    this.swalOptions = this.getSwalOptions();
  }

  ngOnInit() {
    this.setupForm();
  }
  ngOnChanges() {
    this.setupForm();
  }
  setupForm() {
    this.paymentdueDateForm = this.fb.group({
      payment_due_date: [{ value: this.transaction.payment_due_date ?
        moment(this.transaction.payment_due_date) : null , disabled: this.disabled }],
      display_due_date_invoice: [this.transaction.display_due_date_invoice]
    });
  }

  validateDate(event) {
    let sDate;
    let regexp;
    if (event && event.targetElement && event.targetElement.value) {
      regexp = this.transactionService.dateValidator(this.getUserCountry());
      if (regexp.test(event.targetElement.value)) {
        sDate = this.transactionService.dateConvertor(this.getUserCountry(), event.targetElement.value);
        this.paymentDuedateChanged.emit({ ...this.transaction, ...{ payment_due_date: sDate } });
      } else {
        this.warnDateValidAlert.text = 'Invalid Date';
        this.warnDateValidAlert.fire().then(response => {
          if (response.value || response.dismiss) {
            this.paymentdueDateForm.patchValue({
              payment_due_date: null
            });
            this.paymentDuedateChanged.emit({ ...this.transaction, ...{ payment_due_date: null } });
          }
        });
      }
    }
  }
  getSwalOptions() {
    // {showConfirmButton: true, confirmButtonText: 'Continue', showCancelButton: true, showCloseButton: true}
    const options = {
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
      showCancelButton: true
    };
    return this.formService.getSwalOptions(options);
  }

  getUserCountry() {
    return this.userProfileService.getCountryLocalStorage();
  }

}
